import React from 'react';

export default function UnauthenticatedContent() {
    return (
        <React.Fragment>
            
        </React.Fragment>
  );
}
